export default __webpack_public_path__ + "static/media/pt-icon.8ab2f4a0.svg";